var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarMilestone24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "stroke secondary-fill",
    d: "M14.39 16.97 9.97 21.4c-.81.81-2.13.81-2.94 0L5 19.47l-2.39-2.5a2.08 2.08 0 0 1 0-2.94L7.03 9.6a2.08 2.08 0 0 1 2.94 0L12 11.62l2.39 2.4c.81.82.81 2.14 0 2.95Z",
    stroke: "#40465A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "stroke",
    d: "M17 4h2c1.1 0 2 .89 2 1.98v3.58M17 4V3m0 1v1.5M17 4H9m0 0v1.5M9 4V3m0 1H7C5.9 4 5 4.9 5 5.98V8m16 1.56v6.96c0 1.1-.9 1.98-2 1.98h-2.5M21 9.56h-7.5",
    stroke: "#40465A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarMilestone24);
export default __webpack_public_path__ + "static/media/calendar_milestone_24.cfd66ea2aedf463d761cb995d0fbdb76.svg";
export { ForwardRef as ReactComponent };